<div class="main-popup">
        <span class="title">{{'customerChat.LinkExpired' | translate}}</span>
</div>
